<header class="topbar">
  <div class="topbar-sidebar-zone" [class.is-collapsed]="sidebarCollapsed">
    <button type="button" class="hamburger" (click)="toggleMobileSidebar()" aria-label="Open navigation menu">
      <dmp-icon name="menu" size="md" />
    </button>

    <div class="topbar-brand" [attr.aria-label]="appName">
      <dmp-brand-logo
        class="topbar-logo"
        [alt]="appName + ' logo'"
        [showText]="!sidebarCollapsed && !isMobile"
        [priority]="true"></dmp-brand-logo>
    </div>
  </div>

  <div class="topbar-main">
    <nav class="top-tabs" [class.top-tabs--compact]="!showTopTabs" aria-label="Primary views">
      <button type="button" class="sidebar-toggle" (click)="toggleSidebarCollapse()" [attr.title]="collapseToggleTitle"
        [attr.aria-label]="collapseToggleTitle" [attr.aria-expanded]="!sidebarCollapsed" aria-controls="sidebar">
        <dmp-icon [name]="sidebarCollapsed ? 'chevrons-right' : 'menu'" size="md" />
      </button>
      @if (hasTenantBadge) {
        <span
          class="tenant-badge"
          [attr.title]="tenantBadgeTitle"
          [attr.aria-label]="tenantBadgeAriaLabel"
        >
          <span class="tenant-badge__dot" aria-hidden="true"></span>
          <span class="tenant-badge__name">{{ tenantBadgeLabel }}</span>
        </span>
      }
      @if (showTopTabs) {
        <button type="button" class="top-tab" [class.active]="isOverview" (click)="navigateTo('/')"
          title="Command Center" aria-label="Command Center">
          <dmp-icon name="grid" size="md" />
          <span class="top-tab-label">Command Center</span>
        </button>
        <button type="button" class="top-tab" [class.active]="isAssistant" (click)="navigateTo('/assistant')"
          title="AI Assistant" aria-label="AI Assistant">
          <dmp-icon name="spark" size="md" />
          <span class="top-tab-label">AI Assistant</span>
        </button>
      }
    </nav>

    <div class="topbar-actions">
      <button
        type="button"
        class="theme-toggle-btn"
        (click)="toggleTheme()"
        [attr.title]="themeToggleLabel"
        [attr.aria-label]="themeToggleLabel">
        <dmp-icon [name]="themeToggleIcon" size="md" />
      </button>

      <div class="user-menu" [class.is-open]="userMenuOpen">
        <button
          type="button"
          class="avatar user-menu-trigger"
          (click)="toggleUserMenu($event)"
          [attr.aria-expanded]="userMenuOpen"
          aria-haspopup="menu"
          [attr.aria-label]="'Account menu for ' + displayFirstName">
          {{ displayInitials }}
        </button>

        @if (userMenuOpen) {
          <div class="user-menu-dropdown" role="menu" (click)="$event.stopPropagation()">
            <div class="user-menu-header" role="none">
              <div class="user-menu-name">{{ displayFirstName }} {{ displayLastName }}</div>
              @if (displayEmail) {
                <div class="user-menu-email">{{ displayEmail }}</div>
              }
              <div class="user-menu-role">{{ displayRole }}</div>
              @if (tenantBadgeLabel) {
                <div class="user-menu-tenant" [attr.title]="tenantBadgeTitle">{{ tenantBadgeLabel }}</div>
              }
            </div>
            <button type="button" class="user-menu-item" role="menuitem" (click)="onProfile($event)">
              <dmp-icon name="user" size="sm" />
              <span>Profile</span>
            </button>
            <button type="button" class="user-menu-item" role="menuitem" (click)="onSettings($event)">
              <dmp-icon name="settings" size="sm" />
              <span>Change password</span>
            </button>
            <div class="user-menu-divider" role="separator"></div>
            <button type="button" class="user-menu-item user-menu-item--danger" role="menuitem" (click)="onLogout($event)">
              <dmp-icon name="log-out" size="sm" />
              <span>Logout</span>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</header>